var map = {
	"./account.svg": "ef22",
	"./class.svg": "08f6",
	"./onaccount.svg": "a489",
	"./onclass.svg": "78f5",
	"./onorder.svg": "1de2",
	"./onproduct.svg": "cffb",
	"./onuser.svg": "30c4",
	"./order.svg": "11ff",
	"./product.svg": "8d30",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";